import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatOrderType, formatOrderedTime } from "./orderUtils";

export const downloadOrdersPDF = (orders, currencySymbol, timezone, restaurantName, dateRangeStr, totalOrders, totalSales, orderType, status) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(31, 41, 55); 
  const nameText = restaurantName || "Restaurant";
  const textWidth = doc.getTextWidth(nameText);
  doc.text(nameText, (pageWidth - textWidth) / 2, 22);

  doc.setFontSize(14);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(107, 114, 128); 
  const reportTitle = "Orders Report";
  const titleWidth = doc.getTextWidth(reportTitle);
  doc.text(reportTitle, (pageWidth - titleWidth) / 2, 30);

  doc.setDrawColor(229, 231, 235); 
  doc.setLineWidth(0.5);
  doc.line(14, 35, pageWidth - 14, 35);

  const hasExtraFilters = (orderType && orderType !== "all" && orderType !== "") || (status && status !== "all" && status !== "");
  const barHeight = hasExtraFilters ? 18 : 12;

  doc.setFillColor(249, 250, 251);
  doc.setDrawColor(229, 231, 235);  
  doc.setLineWidth(0.5);
  doc.rect(14, 40, pageWidth - 28, barHeight, 'FD');

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(55, 65, 81); 

  doc.text(`Date Range:`, 18, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(dateRangeStr || "All Dates", 42, 47.5);

  doc.setFont("helvetica", "bold");
  const middleStart = pageWidth / 2 - 20;
  doc.text(`Total Orders:`, middleStart, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(`${totalOrders || 0}`, middleStart + 28, 47.5);

  const formattedSales = Number(totalSales || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  doc.setFont("helvetica", "bold");
  const salesText = `Total Sales: `;
  const valueWidth = doc.getTextWidth(formattedSales);
  const labelWidth = doc.getTextWidth(salesText);
  const rightEnd = pageWidth - 18;

  doc.text(salesText, rightEnd - valueWidth - labelWidth, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(formattedSales, rightEnd - valueWidth, 47.5);

  if (hasExtraFilters) {
    let filterText = [];
    if (orderType && orderType !== "all" && orderType !== "") {
      filterText.push(`Type: ${String(orderType).charAt(0).toUpperCase() + String(orderType).slice(1)}`);
    }
    if (status && status !== "all" && status !== "") {
      filterText.push(`Status: ${String(status).charAt(0).toUpperCase() + String(status).slice(1)}`);
    }

    doc.setFont("helvetica", "bold");
    doc.text(`Filters Applied:`, 18, 53.5);
    doc.setFont("helvetica", "normal");
    doc.text(filterText.join("   |   "), 48, 53.5);
  }

  const columns = [
    "Order ID",
    "Order Type",
    "Ordered Time",
    "Phone",
    "Price",
    "Products",
    "Driver",
    "Status",
  ];

  const rows = (orders || []).map((order) => {
    const products = (order.products || [])
      .filter((p) => p.active)
      .map((p) => `${p.productTitle?.split(",")[0] || "Unnamed"} (x${p.quantity})`)
      .join("\n");

    const driver = order.status === "pending"
      ? "Not Assigned"
      : order.assignedDriver?.name || order.driverName || "Not Assigned";

    return [
      order.orderId,
      formatOrderType(order.orderType),
      formatOrderedTime(order.createdAt, timezone),
      order.phoneNumber || "-",
      Number(order.amount || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      products,
      driver,
      order.status,
    ];
  });

  doc.autoTable({
    head: [columns],
    body: rows,
    startY: 40 + barHeight + 5,
    theme: 'striped',
    headStyles: {
      fillColor: [31, 41, 55], 
      textColor: 255,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'center' },
      4: { halign: 'right' },
      5: { halign: 'left' },
      6: { halign: 'center' },
      7: { halign: 'center' },
    },
    alternateRowStyles: {
      fillColor: [249, 250, 251] 
    },
    styles: {
      fontSize: 8,
      cellPadding: 3,
      textColor: [55, 65, 81],
      lineColor: [229, 231, 235], 
      lineWidth: 0.1,
    },
  });

  
  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(8);
  doc.setTextColor(156, 163, 175); 
  const generationDate = new Date().toLocaleString();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`Generated on ${generationDate}`, 14, doc.internal.pageSize.getHeight() - 10);
    const pageText = `Page ${i} of ${pageCount}`;
    const pageTextWidth = doc.getTextWidth(pageText);
    doc.text(pageText, pageWidth - 14 - pageTextWidth, doc.internal.pageSize.getHeight() - 10);
  }

  const currentDate = new Date().toISOString().split('T')[0];
  doc.save(`Orders-Report-${currentDate}.pdf`);
};

export const downloadCustomerReportPDF = (customers, currencySymbol, timezone, restaurantName, dateRangeStr, totalCustomers, totalSales) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

 
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(31, 41, 55); 
  const nameText = restaurantName || "Restaurant";
  const textWidth = doc.getTextWidth(nameText);
  doc.text(nameText, (pageWidth - textWidth) / 2, 22);

  doc.setFontSize(14);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(107, 114, 128); 
  const reportTitle = "Customer Report";
  const titleWidth = doc.getTextWidth(reportTitle);
  doc.text(reportTitle, (pageWidth - titleWidth) / 2, 30);

  
  doc.setDrawColor(229, 231, 235); 
  doc.setLineWidth(0.5);
  doc.line(14, 35, pageWidth - 14, 35);

  doc.setFillColor(249, 250, 251);
  doc.setDrawColor(229, 231, 235); 
  doc.setLineWidth(0.5);
  doc.rect(14, 40, pageWidth - 28, 12, 'FD'); 

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(55, 65, 81);

  doc.text(`Date Range:`, 18, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(dateRangeStr, 42, 47.5);

  doc.setFont("helvetica", "bold");
  const middleStart = pageWidth / 2 - 20;
  doc.text(`Total Customers:`, middleStart, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(`${totalCustomers}`, middleStart + 32, 47.5);

  const formattedSales = Number(totalSales || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  doc.setFont("helvetica", "bold");
  const salesText = `Total Sales: `;
  const valueWidth = doc.getTextWidth(formattedSales);
  const labelWidth = doc.getTextWidth(salesText);
  const rightEnd = pageWidth - 18;

  doc.text(salesText, rightEnd - valueWidth - labelWidth, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(formattedSales, rightEnd - valueWidth, 47.5);

  const columns = [
    "Customer Name",
    "Mobile",
    "Orders",
    "Sales",
    "Last Order Date",
  ];

  const rows = customers.map((customer) => [
    customer.customerName || "Guest",
    customer.mobile || "-",
    customer.orders ?? 0,
    Number(customer.sales || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    formatOrderedTime(customer.lastOrderDate, timezone),
  ]);

  doc.autoTable({
    head: [columns],
    body: rows,
    startY: 55,
    theme: 'striped',
    headStyles: {
      fillColor: [31, 41, 55], 
      textColor: 255,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'right' },
      4: { halign: 'center' },
    },
    alternateRowStyles: {
      fillColor: [249, 250, 251] 
    },
    styles: {
      fontSize: 9,
      cellPadding: 4,
      textColor: [55, 65, 81], 
      lineColor: [229, 231, 235], 
      lineWidth: 0.1,
    },
  });


  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(8);
  doc.setTextColor(156, 163, 175); 
  const generationDate = new Date().toLocaleString();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`Generated on ${generationDate}`, 14, doc.internal.pageSize.getHeight() - 10);
    const pageText = `Page ${i} of ${pageCount}`;
    const pageTextWidth = doc.getTextWidth(pageText);
    doc.text(pageText, pageWidth - 14 - pageTextWidth, doc.internal.pageSize.getHeight() - 10);
  }

  const currentDate = new Date().toISOString().split('T')[0];
  doc.save(`Customer-Report-${currentDate}.pdf`);
};

export const downloadProductReportPDF = (
  products,
  currencySymbol,
  timezone,
  restaurantName,
  dateRangeStr,
  totalProducts,
  totalQty,
  totalSales,
  qrEnabled = true
) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(31, 41, 55);
  const nameText = restaurantName || "Restaurant";
  const textWidth = doc.getTextWidth(nameText);
  doc.text(nameText, (pageWidth - textWidth) / 2, 22);

  doc.setFontSize(14);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(107, 114, 128);
  const reportTitle = "Product Report";
  const titleWidth = doc.getTextWidth(reportTitle);
  doc.text(reportTitle, (pageWidth - titleWidth) / 2, 30);

  doc.setDrawColor(229, 231, 235);
  doc.setLineWidth(0.5);
  doc.line(14, 35, pageWidth - 14, 35);

  const barHeight = 18;

  doc.setFillColor(249, 250, 251);
  doc.setDrawColor(229, 231, 235);
  doc.setLineWidth(0.5);
  doc.rect(14, 40, pageWidth - 28, barHeight, "FD");

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(55, 65, 81);

  doc.text(`Date Range:`, 18, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(dateRangeStr || "All Dates", 42, 47.5);

  doc.setFont("helvetica", "bold");
  const middleStart = pageWidth / 2 - 22;
  doc.text(`Total Products:`, middleStart, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(`${totalProducts ?? 0}`, middleStart + 30, 47.5);

  const formattedSales = Number(totalSales || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  doc.setFont("helvetica", "bold");
  const salesText = `Total Sales: `;
  const valueWidth = doc.getTextWidth(formattedSales);
  const labelWidth = doc.getTextWidth(salesText);
  const rightEnd = pageWidth - 18;

  doc.text(salesText, rightEnd - valueWidth - labelWidth, 47.5);
  doc.setFont("helvetica", "normal");
  doc.text(formattedSales, rightEnd - valueWidth, 47.5);

  doc.setFont("helvetica", "bold");
  doc.text(`Total Items Sold:`, 18, 53.5);
  doc.setFont("helvetica", "normal");
  doc.text(`${totalQty ?? 0}`, 52, 53.5);

  const columns = [
    "Product Name",
    "Dine-in Qty",
    ...(qrEnabled ? ["QR Qty"] : []),
    "Takeaway Qty",
    "Online Qty",
    "Total Qty",
    "Sales",
  ];

  const rows = (products || []).map((product) => [
    product.productName || "Unnamed",
    product.dineInQty ?? 0,
    ...(qrEnabled ? [product.qrQty ?? 0] : []),
    product.takeawayQty ?? 0,
    product.onlineQty ?? 0,
    product.totalQty ?? 0,
    Number(product.totalSales || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  ]);

  const lastColIndex = columns.length - 1;
  const columnStyles = columns.reduce((styles, _col, index) => {
    if (index === 0) {
      styles[index] = { halign: "left" };
    } else if (index === lastColIndex) {
      styles[index] = { halign: "right" };
    } else {
      styles[index] = { halign: "center" };
    }
    return styles;
  }, {});

  doc.autoTable({
    head: [columns],
    body: rows,
    startY: 40 + barHeight + 5,
    theme: "striped",
    headStyles: {
      fillColor: [31, 41, 55],
      textColor: 255,
      fontStyle: "bold",
      halign: "center",
    },
    columnStyles,
    alternateRowStyles: {
      fillColor: [249, 250, 251],
    },
    styles: {
      fontSize: 9,
      cellPadding: 4,
      textColor: [55, 65, 81],
      lineColor: [229, 231, 235],
      lineWidth: 0.1,
    },
  });

  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(8);
  doc.setTextColor(156, 163, 175);
  const generationDate = new Date().toLocaleString();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`Generated on ${generationDate}`, 14, doc.internal.pageSize.getHeight() - 10);
    const pageText = `Page ${i} of ${pageCount}`;
    const pageTextWidth = doc.getTextWidth(pageText);
    doc.text(pageText, pageWidth - 14 - pageTextWidth, doc.internal.pageSize.getHeight() - 10);
  }

  const currentDate = new Date().toISOString().split("T")[0];
  doc.save(`Product-Report-${currentDate}.pdf`);
};
